
define('text!modules/reporting/campaigns/reachFrequency/templates/reachFrequency.html',[],function () { return '<div class="w-panel-body w-reach-frequency-panel"></div>\n';});

